import React, { useCallback } from 'react'
import { ISelectOption } from 'components/forms/Selects'
import DryVanIcon from 'transfix-icons/build/DryVanIcon'
import { SingleSelect, ISingleSelectProps } from 'transfix-ui/components/SingleSelect'
import { EQUIPMENT_OPTIONS } from 'apps/fleet-planner/constants/marketplace'

type TOmittedProp =
  | 'id'
  | 'dataTest'
  | 'icon'
  | 'label'
  | 'options'
  | 'onSelect'
  | 'selected'
  | 'emptyStateLabel'

export interface IEquipmentFilterSingleSelectProps extends Omit<ISingleSelectProps, TOmittedProp> {
  /**
   * @example 'live-live'
   */
  value: string | undefined
  onChange: (value: string | undefined) => void
}

export const EquipmentFilterSingleSelect = ({
  onChange,
  value,
  ...props
}: IEquipmentFilterSingleSelectProps) => {
  const selectHandler: ISingleSelectProps['onSelect'] = useCallback(
    (option: ISelectOption<string> | undefined) => {
      const { value: newValue } = option || {}
      onChange(newValue)
    },
    [onChange]
  )

  return (
    <SingleSelect
      id='dedicated-lanes-equipment-filter'
      dataTest='dedicated-lanes-equipment-filter'
      label='Any Equipment'
      emptyStateLabel='No equipment type available'
      icon={<DryVanIcon size='large' />}
      selected={value}
      options={EQUIPMENT_OPTIONS}
      onSelect={selectHandler}
      {...props}
    />
  )
}
